import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { TokenHelperService } from 'app/global/token-helper.service';

// The token/id route params stay live in the URL for the whole signing
// session (see 's/:id/:token' in app-routing.module.ts), so the URL is a
// more reliable source than sessionStorage/localStorage, which iOS Safari
// can silently wipe or fail to write (e.g. after a background tab reload,
// or in Private Browsing where writes throw and are swallowed).
function findRouteParam(root: ActivatedRouteSnapshot, key: string): string | null {
    let node: ActivatedRouteSnapshot | null = root;
    while (node) {
        const value = node.paramMap.get(key);
        if (value) return value;
        node = node.firstChild;
    }
    return null;
}

export const sessionStoredTokenInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.headers.has('signing_area')) {
        const router = inject(Router);
        const tokenHelper = inject(TokenHelperService);

        const root = router.routerState.snapshot.root;
        const urlDocId = findRouteParam(root, 'id');
        const urlToken = findRouteParam(root, 'token');
        const signingToken = urlToken ?? tokenHelper.getSigningPagetoken(urlDocId ?? undefined);

        request = request.clone({
            setHeaders: {
                'token': `${signingToken}`
            }
        });
    }

    return next(request);
};
